export default "__VITE_ASSET__CQC1itt___"